<template>
  <div v-if="isShowHeader" class="banner"></div>
  <div v-if="isShowHeader"  class="back-home">
    <van-icon color="#fff" size="28" name="arrow-left" @click="handleGoBack"/>
    <div class="title">营养报告</div>
  </div>
  <div class="business-reports">
    <div class="report-date" @click="handleDataClick">
      <div class="date-des">{{ formData.date }}</div>
      <van-icon color="#000000" size="22" name="tosend" />
    </div>

    <div class="report-content">
      <div class="report-total-container">
        <div class="report-total" @click="handleYongClick">
          <span class="title-label">用餐次数</span>
          <span class="title-value">{{ state.eatCount ?? 0 }}</span>
        </div>
        <div class="report-total" @click="handleChuClick">
          <span class="title-label">出入书院</span>
          <span class="title-value" style="color: #91cc75">{{
            state.comeCount ?? 0
          }}</span>
        </div>
      </div>
    </div>
    <div class="report-chart">
      <div class="report-title">餐食种类</div>
      
      <Charts ref="reportChart" v-if="state.reportData" :data="state.reportData"/>
      <EmptyData style="margin-top: 100px" v-if="!state.reportData"/>
    </div>
    <div class="report-table">
      <div class="report-title">营养达标分析</div>
      <SortPaginationTable
        style="margin-top: 10px"
        :data="state.tableList"
        :columns="columns"
      />
    </div>


    <div class="business-reports-wx" v-if="isShowWx">
      <div class="reports-wx-left" style="margin-top: 12px">
        <van-image
          width="96"
          height="36"
          fit="cover"
          :src="BackImage"
        />
        <div style="margin-top: 22px;" class="bottom-text">中学生高端托管引领者</div>
      </div>
      <div class="reports-wx-right">
        <van-image
          width="58"
          height="58"
          fit="cover"
          :src="WxXiaoImage"
          @click="showImagePre"
        />
        <div class="bottom-text">扫码进入小程序</div>
      </div>
    </div>
    <van-calendar
      :min-date="state.minDate"
      :max-date="state.maxDate"
      v-model:show="state.calendarShow"
      @confirm="onConfirm"
    />
  </div>

  
</template>
<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { showLoadingToast, Calendar } from "vant";
import Charts from "@/components/charts.vue";

import { postDayDishDris } from "@/api/report";
import SortPaginationTable from "@/components/business/SortPaginationTable.vue";
import dayjs from "dayjs";
import EmptyData from '@/components/EmptyData.vue';
import BackImage from '@/assets/youyiyoujia_back.png'
import WxXiaoImage from '@/assets/wx_xiao.png'
import { showImagePreview } from 'vant';

const columns = [
  {
    title: "营养指标",
    dataIndex: "name",
    width: 120,
    tag: true,
    start: true,
  },
  {
    title: "指标值",
    dataIndex: "target",
    width: 80,
  },
  {
    title: "参考值",
    dataIndex: "init",
    width: 80,
  },
  {
    title: "对比",
    dataIndex: "point",
    width: 80,
  },
];
const colors = [
  "#EE6666",
  "#FAC858",
  "#91CC75",
  "#FFC19F",
  "#CC9EFF",
  "#73C0DE",
  "#3098D8",
  "#5470C6",
  "#86A9BE",
  "#6B94AD",
  "#17435E",
];

export default defineComponent({
  components: {
    Charts,
    SortPaginationTable,
    Calendar,
    EmptyData
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const reportChart = ref(null)

    const isShowHeader = ref(true)

    const isShowWx = ref(false)

    const state = reactive({
      reportData: null,
      tableList: [],
      comeCount: 0,
      eatCount: 0,
      foodNum: 0,
      calendarShow: false,
      maxDate: new Date(dayjs().format("YYYY-MM-DD")),
      minDate: new Date(dayjs().subtract(1, "year").format("YYYY-MM-DD")),
    });

    const formData = reactive({
      date: dayjs().format("YYYY-MM-DD"),
    });

    onMounted(async () => {
      if(route?.query?.token) {
        localStorage.setItem('token', route?.query?.token)
      }

      if(route?.query?.source && route?.query?.source == 'weixin') {
        isShowHeader.value = false
      }

      if(route?.query?.source && route?.query?.source == 'weixin') {
        isShowWx.value = true
      }

      queryDayDishDris();
    });

    const handleYongClick = () => {
        uni.navigateTo({
          url: "/pages/food/history-list/history-list",
        });
    }

    const handleChuClick = () => {
        uni.navigateTo({
          url: "/pages/college/enterRecords/enterRecords",
        });
    }

    const handleGoBack = () => {
        uni.navigateBack();
    }

    const queryDayDishDris = async () => {
      try {
        const result = await postDayDishDris(
          {
            queryTime: formData.date,
            userId: route?.query?.userId,
          },
          route?.query?.token
        );

        console.log("result====", result);
        if (result.code == "00") {
          state.foodNum = result.data.foodNum;
          state.reportData = result.data.foodTypes;
          reportChart.value && reportChart.value.resizeChart()
          state.tableList = result.data.jsonArray.map((item, index) => {
            return {
              ...item,
              tagValue: colors[index],
            };
          });
          state.comeCount = result.data.comeCount;
          state.eatCount = result.data.eatCount;
          
        } else {
          state.reportData = null;
          state.tableList = 0;
          state.comeCount = 0;
          state.eatCount = 0;
          state.foodNum = 0;
        }
      } catch (error) {}
    };

    const onConfirm = (option) => {
      formData.date = dayjs(option).format("YYYY-MM-DD");
      state.calendarShow = false;
      queryDayDishDris();
    };

    const handleDataClick = () => {
      console.log("点击选择时间");
      state.calendarShow = true;
    };

    const showImagePre = () => {
      showImagePreview([WxXiaoImage]);
    }

    return {
      state,
      columns,
      onConfirm,
      formData,
      handleDataClick,
      handleGoBack,
      handleYongClick,
      handleChuClick,
      reportChart,
      isShowHeader,
      isShowWx,
      BackImage,
      WxXiaoImage,
      showImagePre
    };
  },
});
</script>

<style scoped>
.banner {
  width: 100%;
  height: 180px;
  background-size: cover;
  position: absolute;
  left: 0;
  top: 0;
  background-image: url("../assets/banner.png");
  background-repeat: repeat;
  z-index: 99;
}

.title {
  color: #fff;
  font-size: 18px;
  text-align: center;
  width: calc(100% - 70px);
  font-weight: 600;
}

.back-home {
  z-index: 100;
  margin-top: 44px;
  position: relative;
  text-align: left;
  margin-left: 22px;
  display: flex;
}
.business-reports {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding-bottom: 22px;
  z-index: 100;
  margin-top: 14px;
  position: relative;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.report-total-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.report-total {
  display: flex;
  flex-direction: column;
}

.title-label {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #000000;
}

.title-value {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #fac858;
  margin-top: 12px;
}

.report-content {
  margin: 0 10px;
  padding-top: 14px;
  width: calc(100% - 20px);
  background-color: #fff;
  margin: 0 10px;
  border-radius: 7px;
  display: flex;
  height: 124px;
}
.report-chart {
  height: 380px;
  width: calc(100% - 20px);
  background-color: #fff;
  margin: 0 10px;
  border-radius: 7px;
  margin-top: 12px;
}

.report-title {
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #000000;
  text-align: left;
  padding-left: 10px;
  padding-top: 10px;
}

.report-table {
  width: calc(100% - 20px);
  background-color: #fff;
  margin: 0 10px;
  border-radius: 7px;
  margin-top: 12px;
}

.report-date {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 12px;
  padding-top: 12px;
  margin-right: 20px;
}

.date-des {
  margin-right: 12px;
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
}

:deep(.van-calendar__selected-day) {
    background: #063051
}
:deep(.van-calendar__confirm) {
    background: #063051;
    height: 44px;
}

.bottom-text {
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 11px;
  color: #28526F;   
  margin-top: 10px;
}

.business-reports-wx {
  display: flex;
  justify-content: space-between;
}

.reports-wx-left {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reports-wx-right {
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
